import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
	selector: 'img',
	standalone: false,
})
export class LazyImageLoadingDirective {
	el = inject(ElementRef);

	constructor() {
		const supports = 'loading' in HTMLImageElement.prototype;

		if (supports) {
			this.el.nativeElement.setAttribute('loading', 'lazy');
		}
	}
}
